<template>
  <div v-if="visibleErrors.length > 0" class="app-form-errors" aria-live="polite">
    <p class="app-form-errors__title">Please fix the following before creating the user:</p>
    <ul class="app-form-errors__list">
      <li v-for="message in visibleErrors" :key="message">{{ message }}</li>
    </ul>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from "vue"

const props = defineProps({
  existingLogins: {
    type: Array,
    default: () => []
  },
  initialErrors: {
    type: Array,
    default: () => []
  }
})

const loginValue = ref("")
const emailValue = ref("")
const passwordValue = ref("")
const passwordConfirmationValue = ref("")

let loginInput = null
let emailInput = null
let passwordInput = null
let passwordConfirmationInput = null
let submitButton = null

const normalizedExistingLogins = computed(() =>
  (props.existingLogins || []).map((login) => String(login).trim().toLowerCase())
)

const clientErrors = computed(() => {
  const errors = []
  const normalizedLogin = loginValue.value.trim().toLowerCase()

  if (loginValue.value.trim() === "") {
    errors.push("Account name is required.")
  } else if (normalizedExistingLogins.value.includes(normalizedLogin)) {
    errors.push("Account name has already been taken.")
  }

  if (emailValue.value.trim() === "") {
    errors.push("Email is required.")
  }

  if (passwordValue.value === "") {
    errors.push("Login password is required.")
  }

  if (passwordConfirmationValue.value === "") {
    errors.push("Confirm login password is required.")
  }

  if (
    passwordValue.value !== "" &&
    passwordConfirmationValue.value !== "" &&
    passwordValue.value !== passwordConfirmationValue.value
  ) {
    errors.push("Login password and confirmation must match.")
  }

  return errors
})

const visibleErrors = computed(() => {
  const messages = [...props.initialErrors, ...clientErrors.value]
  return Array.from(new Set(messages))
})

function syncState() {
  loginValue.value = loginInput?.value || ""
  emailValue.value = emailInput?.value || ""
  passwordValue.value = passwordInput?.value || ""
  passwordConfirmationValue.value = passwordConfirmationInput?.value || ""

  if (submitButton) {
    submitButton.disabled = visibleErrors.value.length > 0
  }
}

function attachListeners() {
  ;[loginInput, emailInput, passwordInput, passwordConfirmationInput]
    .filter(Boolean)
    .forEach((field) => field.addEventListener("input", syncState))
}

function detachListeners() {
  ;[loginInput, emailInput, passwordInput, passwordConfirmationInput]
    .filter(Boolean)
    .forEach((field) => field.removeEventListener("input", syncState))
}

onMounted(() => {
  loginInput = document.querySelector('input[name="user[login]"]')
  emailInput = document.querySelector('input[name="user[email]"]')
  passwordInput = document.querySelector('input[name="user[password]"]')
  passwordConfirmationInput = document.querySelector('input[name="user[password_confirmation]"]')
  submitButton = document.getElementById("user-create-submit")

  attachListeners()
  syncState()
})

onBeforeUnmount(() => {
  detachListeners()
})
</script>
